// extracted by mini-css-extract-plugin
export var configurationSection = "_rn-0";